module.exports = __webpack_public_path__ + "static/media/image_20.2fe187bf.png";